import type { NextPage } from 'next'
import Top from 'components/pages/Top'

const Page: NextPage = () => {
  return <Top />
}

export default Page
